import type { ReactElement } from 'react';
import { useNavigate } from 'react-router';

import { useSession } from '../../../lib/api/session-context';
import { ONBOARDING_ROUTES } from '../routes';

import { IntroScreen } from './IntroScreen';

/**
 * Route element of E1: feeds {@link IntroScreen} from the session and leads to E2 (S3 R3, R4).
 *
 * `onStart` is the router's way to learn that E1 was done, so it is not shown again at `/` in this
 * launch (R5). It sends no request (R12). The affiliate is the one the S2 exchange returned.
 */
export function IntroRoute({ onStart }: { onStart: () => void }): ReactElement {
  const session = useSession();
  const navigate = useNavigate();
  // Under SessionGate the session is always `ready`; E1 never needs another state.
  const affiliateName =
    session.status === 'ready' ? (session.affiliate?.displayName ?? null) : null;
  return (
    <IntroScreen
      affiliateName={affiliateName}
      onStart={() => {
        onStart();
        void navigate(ONBOARDING_ROUTES.telegram);
      }}
    />
  );
}
